import { cn } from "@beweegbaas/ui";
import { createFileRoute } from "@tanstack/react-router";
import { motion } from "motion/react";
import { useEffect, useState } from "react";
import { LessonPageLayout } from "#/modules/les.leerling-gestuurd/components/lesson-page-layout";
import { SociaalEmotioneelQuestion } from "#/modules/les.leerling-gestuurd/components/question.sociaal-emotioneel";
import { SuccessAnimation } from "#/modules/les.leerling-gestuurd/components/shared.success-animation";
import {
  getSociaalEmotioneelThemaById,
  getStudentNameById,
} from "#/modules/les.leerling-gestuurd/helpers.les.leerling";
import { useLeerlingGestuurdeLes } from "#/modules/les.leerling-gestuurd/use-leerling-gestuurde-les";

export const Route = createFileRoute(
  "/$locale/{-$schoolyear}/_authenticated/$school/lesson/$lesson/student/$student/social/$id/",
)({
  component: StudentSocialPage,
});

function StudentSocialPage() {
  const params = Route.useParams();
  const { lesson } = useLeerlingGestuurdeLes();
  const [isSuccess, setIsSuccess] = useState(false);
  const socialTheme = getSociaalEmotioneelThemaById(lesson, params.id);
  const student = getStudentNameById(lesson, params.student);

  useEffect(() => {
    setIsSuccess(false);
  }, [params.id, params.student]);

  return (
    <LessonPageLayout
      title={
        <h1 className="m-0 flex items-center justify-center gap-4">
          {student} — {socialTheme?.name}
          <IconHugeiconsBrain02 className="size-[2em] shrink-0 opacity-50" />
        </h1>
      }
      contentClassName={cn("max-w-[1200px] gap-20", {})}
      showBackButton={true}
    >
      <SuccessAnimation isSuccess={isSuccess} lessonId={params.lesson} />

      <motion.div
        className="w-full"
        animate={isSuccess ? { opacity: 0, scale: 0.9 } : { opacity: 1, scale: 1 }}
      >
        <SociaalEmotioneelQuestion
          sociaalEmotioneelThema={socialTheme!}
          activityName={socialTheme?.name}
          onSuccess={() => setIsSuccess(true)}
        />
      </motion.div>
    </LessonPageLayout>
  );
}
